var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('main-visual'), _vm._v(" "), _c('comic'), _vm._v(" "), _c('video-section'), _vm._v(" "), _c('twitter'), _vm._v(" "), _c('quiz'), _vm._v(" "), _c('profile'), _vm._v(" "), _c('global-footer')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b33e1d20","hasScoped":false,"transformToRequire":{"video":"src","source":"srcset","img":["src","srcset"],"image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Index.vue
// module id = 102
// module chunks = 0